<template>
    <div class="children-home-page">
        <div class="page-image-block">
            <img :src="bannerImage" v-show="channelWidth>768"></img>
            <img :src="phoneBannerImage" v-show="channelWidth<=768"/>
        </div>
        <!--        what can we do-->
        <div class="home-page-content-block">
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            <el-col class="recommend-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16">
                <div>
                    <title-block :list-index="'0'"></title-block>
                </div>
                <div class="recommend-body-content">
                    <div class="content-item" v-for="item in toDoList">
                        <img :src="item.image"/>
                        <div class="item-title">{{item.name}}</div>
                        <div class="item-info">{{item.info}}</div>
                    </div>
                </div>
            </el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
        </div>
        <!--        User scenario-->
        <div class="home-page-content-block hasBg" v-show="channelWidth>768">
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            <el-col class="recommend-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16">
                <div style="color: #FFFFFF">
                    <title-block :list-index="'1'"></title-block>
                </div>
                <div class="recommend-body-content" style="margin-top: 15px">
                    <image-block :isShow="true"></image-block>

                </div>

            </el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
        </div>
        <div class="home-page-content-block hasBg" v-show="channelWidth<=768">
            <el-col class="recommend-body">
                <div style="color: #FFFFFF">
                    <title-block :list-index="'1'"></title-block>
                </div>
                <div class="recommend-body-content" style="margin-top: 15px">
                    <image-block :isShow="false"></image-block>
                </div>
            </el-col>

        </div>
<!--        solution-->
        <div class="home-page-content-block solution-bg">
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            <el-col class="recommend-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16">
                <div>
                    <title-block :list-index="'2'"></title-block>
                </div>
                <div class="recommend-body-content" style="margin-top: 15px">
                    <div class="solution-list">
                        <div class="list-item" v-for="(item,index) in solutionList" @click="jumpTo(index)" style="cursor: pointer">
                            <img class="item-icon" :src="item.icon"/>
                            <div class="item-content">
                                <div class="content-title">{{item.name}}</div>
                                <div class="content-type" style="margin: 10px 0">{{item.englishName}}</div>
                                <div class="content-type" v-if="channelWidth>768">{{item.info}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
        </div>
<!--        移动端 解决方案-->
<!--        <div class="home-page-content-block solution-bg" style="padding:30px 0" v-show="channelWidth<=768">-->
<!--            <el-col class="recommend-body">-->
<!--                <div>-->
<!--                    <title-block :list-index="'2'"></title-block>-->
<!--                </div>-->
<!--                <div class="carousel-body-content" style="margin-top: 15px">-->
<!--                    <div class="solution-list" style="width: 100%">-->
<!--                        <el-carousel height="100px" type="card">-->
<!--                            <el-carousel-item class="list-carousel-item" v-for="(item,index) in solutionList" :key="index">-->
<!--                                <div class="carousel-content" @click="jumpTo(index)">-->
<!--                                    <div class="title-image">-->
<!--                                        <img class="item-icon" :src="item.icon"/>-->
<!--                                        <div class="content-title">-->
<!--                                            {{item.name}}-->
<!--                                        </div>-->
<!--                                    </div>-->

<!--                                    <div class="item-content">-->
<!--                                        <div class="content-type">{{item.info}}</div>-->
<!--                                    </div>-->
<!--                                </div>-->

<!--                            </el-carousel-item>-->
<!--                        </el-carousel>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </el-col>-->
<!--        </div>-->
<!--        Our advantage-->
        <div class="home-page-content-block">
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            <el-col class="recommend-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16">
                <div>
                    <title-block :list-index="'3'"></title-block>
                </div>
                <div class="recommend-body-content" style="margin-top: 15px">
                    <div class="advantage-list">
                        <div class="list-item" v-for="item in advantageList">
                            <img :src="item.icon"/>
                            <div class="item-title">{{item.name}}</div>
                            <div class="item-info" style="text-align: left">{{item.info}}</div>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
        </div>
    </div>
</template>

<script>
    import BannerImage from '../../image/banner.png'
    import phoneBannerImage from '../../image/common/banner_phone.png'
    import ToDoOne from '../../image/to_do_one.png'
    import ToDoTwo from '../../image/to_do_two.png'
    import ToDoThree from '../../image/to_do_three.png'
    import ToDoFour from '../../image/to_do_four.png'
    import UserBg from '../../image/use_bg.png'
    import SolutionIcon1 from '../../image/solution_a.png'
    import SolutionIcon2 from '../../image/solution_b.png'
    import SolutionIcon3 from '../../image/solution_d.png'
    import SolutionIcon4 from '../../image/solution_e.png'
    import SolutionIcon5 from '../../image/solution_f.png'
    import SolutionIcon6 from '../../image/solution_g.png'
    import AdvantageIcon1 from '../../image/advantage_1.png'
    import AdvantageIcon2 from '../../image/advantage_2.png'
    import AdvantageIcon3 from '../../image/advantage_3.png'
    import AdvantageIcon4 from '../../image/advantage_4.png'
    //组件引入
    import TitleBlock from '../../../components/home-page-title-block/home-page-title-block'
    import ImageBlock from '../../../components/home-page-image-hover/home-page-image-hover'
    export default {
        name: "children-home-page",
        components:{
            TitleBlock,
            ImageBlock,

        },
        data(){
            return{
                channelWidth:null,
                bannerImage:BannerImage,
                phoneBannerImage,
                userBg:UserBg,
                toDoList:[
                    {name:'物联网数据采集',info:'物联网数据采集，大数据的采集，适用于物联网，环境监控设备制造，数据监控系统，高效节能，解决工业设备的基础问题。',image:ToDoOne},
                    {name:'实时监控平台',info:'结合现代音、视频压缩技术、网络通讯技术、计算机控制技术、流媒体传输技术，采用模块化的软件设计理念，将不同客户的需求以组件模块的方式实现。',image:ToDoTwo},
                    {name:'终端远程控制',info:'远程终端就是利用服务器安装的终端服务端口，安装远程控制工具，可以在任何地方进行登录服务器，从而实现远程控制。',image:ToDoThree},
                    {name:'大数据分析与挖掘',info:'数据挖掘与大数据分析可以从海量数据中，找到值得参考的样型或规则，转换成有价值的信息或知识，让数据搜集和储存方式更加方便。',image:ToDoFour},
                ],
                solutionList:[
                    {name:'教育解决方案',icon:SolutionIcon1,englishName:'Campus solutions',info:'在教育领域（教育管理、教育教学和教育科研）全面深入地运用现代信息技术来促进教育改革与发展的过程。其技术特点是数字化、网络化、智能化和多媒体化，基本特征是开放、共享、交互、协作、泛在。以教育信息化促进教育现代化，用信息技术改变传统模式。',path:'/page/solution/school'},
                    {name:'环保解决方案',icon:SolutionIcon2,englishName:'Environment solutions',info:'智慧环保是物联网技术与环境信息化相结合的概念。信息化的发展为环境保护提供了有效手段，环境信息数据的采集、传输和管理的智能化为提高环境保护工作效用提供了有利的条件。',path:'/page/solution/environment'},
                    {name:'城管解决方案',icon:SolutionIcon3,englishName:'Monitoring solutions',info:'全流程智能化管理，全面提升工作效率，实现精细化管理闭环。全场景覆盖，规范化的管理体系，帮助城管部门实现智能化。',path:'/page/solution/administration'},
                    {name:'化工解决方案',icon:SolutionIcon4,englishName:'Industrial solutions',info:'在数字化工厂的基础上，利用物联网的技术和设备监控技术加强信息管理和服务；清楚掌握生产流程、提高生产过程的可控性、减少生产线上人工的干预、即时正确地采集生产线数据，以及设备设施数据，实现生产全过程的可视化管理。',path:'/page/solution/chemical-industry'},
                    {name:'工地解决方案',icon:SolutionIcon5,englishName:'Building solutions',info:'网络的普及和技术的发展使物联网具备基础条件而传感器技术的发展推动了物联网在建筑行业的应用。',path:'/page/solution/construction'},
                    {name:'农业解决方案',icon:SolutionIcon6,englishName:'Farming solutions',info:'智慧农业就是将物联网技术运用到传统农业中去，运用传感器和软件通过移动平台或者电脑平台对农业生产进行控制，使传统农业更具有"智慧”。',path:'/page/solution/agriculture'},
                ],
                advantageList:[
                    {name:'定制软件',icon:AdvantageIcon1,info:'经验丰富的软件开发人员能够清晰的了解业务工作流程和信息管理概念。'},
                    {name:'一站式全托管服务',icon:AdvantageIcon2,info:'一站式全托管服务为客户提供从开发到使用，从线上到下线全方位的服务体系。'},
                    {name:'多种协议智能解析',icon:AdvantageIcon3,info:'可智能的解析多种通信协议，为客户提供更好的服务。'},
                    {name:'大数据分析能力',icon:AdvantageIcon4,info:'大数据分析技术包括数据收集、数据存取、基础架构、数据处理、统计分析等。'},
                ]
            }
        },
        watch:{
            /**
             * 浏览器宽度变化赋值
             * @param newVal
             */
            '$store.state.screenWidth'(newVal){
                // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
                if (!this.timer) {
                    // 一旦监听到的productWidth值改变，就将其重新赋给data里的channelWidth.
                    this.channelWidth = newVal
                    this.timer = true;
                    setTimeout(() => {
                        // console.log(this.channelWidth);
                        this.timer = false;
                    }, 400);
                }
            }
        },
        mounted() {
            //获取浏览器宽度
            this.channelWidth = this.$store.state.screenWidth;

        },
        methods:{
            /**
             * 页面跳转
             * @param index
             */
            jumpTo(index){
                let list = this.solutionList;
                this.$router.push(list[index].path);
            }
        }
    }
</script>

<style lang="scss" src="./children-home-page.scss" scoped></style>
<style lang="scss" src="./children-home-page-mini.scss" scoped></style>
